<template>
  <div v-show="!hideWelcomeMessageInFilterDrawer" class="welcome-message mt-3">
    NVE Seriekart hjelper deg å velge hydrologiske tidsserier til analysebruk.
    Finn og eksporter de seriene du ønsker.
    <v-btn right class="pa-0 ma-0" small text @click="hideWelcomeMessage"
      >Skjul</v-btn
    >
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "FilterDrawerWelcomeMessage",
  computed: {
    ...mapState(["hideWelcomeMessageInFilterDrawer"]),
  },
  methods: {
    ...mapActions(["setHideWelcomeMessageInFilterDrawer"]),
    hideWelcomeMessage: function() {
      this.setHideWelcomeMessageInFilterDrawer(true);
    },
  },
};
</script>

<style></style>
